import React from "react";
import PageLayout from "../components/layout/PageLayout";
import { Helmet } from "react-helmet-async";

const secciones = [
  {
    titulo: "1. Introducción",
    texto:
      "En cumplimiento con las leyes de protección de datos personales en el Perú, garantizamos la privacidad y seguridad de la información proporcionada por nuestros usuarios.",
  },
  {
    titulo: "2. Recopilación de Información",
    texto:
      "Podemos recopilar información personal como nombres, correos electrónicos y datos de navegación para ofrecerte una mejor experiencia en nuestro sitio.",
  },
  {
    titulo: "3. Uso de Cookies",
    texto:
      "Este sitio utiliza cookies para mejorar tu navegación y personalizar los contenidos. Al continuar navegando, aceptas el uso de cookies.",
  },
  {
    titulo: "4. Terceros",
    texto:
      "Compartimos información con terceros únicamente cuando es necesario para cumplir con nuestras funciones o requerimientos legales. Nos aseguramos de que estos terceros cumplan con estándares de privacidad adecuados.",
  },
  {
    titulo: "5. Derechos de los Usuarios",
    texto:
      "Tienes derecho a acceder, rectificar o eliminar tus datos personales. Para ejercer estos derechos, contáctanos a través de nuestro correo: soporte@procu.com.",
  },
];

const AvisoPrivacidad = () => {
  return (
    <PageLayout>
      <Helmet>
        <title>Aviso de Privacidad - Procu</title>
        <meta
          name="description"
          content="Consulta nuestro Aviso de Privacidad en Procu. Conoce cómo protegemos tus datos y garantizamos tu seguridad en nuestra plataforma."
        />
        <meta name="keywords" content="aviso de privacidad, protección de datos, Procu, privacidad, seguridad" />
      </Helmet>

      <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6">
        <h1 className="text-3xl font-bold">Aviso de Privacidad</h1>
        <div className="mt-6 flex flex-col gap-6">
          {secciones.map((seccion) => (
            <section key={seccion.titulo}>
              <h2 className="text-lg font-semibold">{seccion.titulo}</h2>
              <p className="mt-2 text-muted-foreground">{seccion.texto}</p>
            </section>
          ))}
        </div>
      </div>
    </PageLayout>
  );
};

export default AvisoPrivacidad;
